import bookkeepingEvidencePrintAPI from '../../../api/bookkeeping/BookkeepingEvidencePrintAPI';
import { INCOME } from '../evidence';
import FiltersType from './listingFiltersTypesConstants';

export const VAT_REGISTER_TYPE_FILTER = (type = INCOME) => {
  return {
    key: 'evidencevatregister.vatregistertype',
    getItems: async () => {
      let { data } = await bookkeepingEvidencePrintAPI.getVatRegisterTypes();
      delete data.pagination;

      return Object.values(data)
        .filter(item => item.evidencekind === type)
        .map((item) => {
          return {
            value: item.id,
            label: item.name,
          };
        });
    },
    reset: async () => ({ value: { fromVal: null, toVal: null } }),
    placeholder: 'Typ rejestru',
    badge: 'Typ rejestru:',
    testName: 'test_filter_evidence_vat_register_type',
    inputType: FiltersType.SELECT_TYPE,
  };
};
